{
  "barsy": {
    "article-fallback": "Article #{{id}}",
    "article-form": {
      "amount-type": "Unit of Measure",
      "amount-type-required": "Select a unit of measure",
      "category": "Category",
      "create-title": "New Article in Barsy",
      "no-category": "— No Category —",
      "toast": {
        "create-error": "Error creating the article: {{message}}",
        "created": "The article was created in Barsy (ID {{id}})."
      }
    },
    "config": {
      "configured": "A Barsy configuration is set. You can edit or delete it.",
      "delete": "Delete",
      "delete-confirm": "Are you sure you want to delete the Barsy configuration?",
      "delete-confirm-title": "Deleting the Barsy Configuration",
      "deleted": "Deleted",
      "load-error": "Loading failed",
      "not-configured": "No Barsy configuration is set for this client.",
      "password": "Barsy Password",
      "password-placeholder-new": "Required when creating",
      "password-placeholder-set": "A password is set - enter a new one if needed",
      "saved": "Saved",
      "send-batch": "Send Batch and Expiration Date",
      "test": "Test Connection",
      "test-failed": "Connection failed",
      "test-success": "The connection is successful",
      "title": "Barsy Settings",
      "url": "Barsy URL",
      "username": "Barsy Username",
      "validation": {
        "password-required": "The password is required when creating the configuration",
        "url-required": "The URL is required",
        "username-required": "The username is required"
      }
    },
    "export": {
      "already-exported": "This document has already been exported to Barsy (ID {{id}}).",
      "attach-files": "Attach the Scanned Document in Barsy",
      "clear-message": "The link to the existing store load in Barsy (ID {{id}}) will be removed and the document will become exportable again. The store load itself will not be deleted from Barsy.",
      "clear-title": "Import as a New Load",
      "column": {
        "article": "Barsy Article",
        "expiration": "Expiration Date",
        "lot": "Lot",
        "package": "Package",
        "quantity": "Quantity",
        "unit-price": "Unit Price"
      },
      "create-article": "Create a New Article in Barsy",
      "create-supplier": "Create a New Supplier in Barsy",
      "currency-label": "Barsy Currency",
      "currency-placeholder": "No selection",
      "depot-label": "Barsy Depot",
      "depot-placeholder": "Select a depot…",
      "doc-date": "Document Date",
      "doc-num": "Document No.",
      "execute": "Export to Barsy",
      "hide-attachments": "Hide the attached files",
      "incomplete-warning": "Fill in all fields (depot, supplier, and an article for every line) to export to Barsy.",
      "item-code": "code: {{code}}",
      "lines-title": "Articles ({{items}})",
      "load-error": "Error loading the incoming document.",
      "new-load": "New Load",
      "no-lines": "The document has no lines.",
      "no-ocr": "The document has no OCR result — run AI recognition first.",
      "package-none": "None",
      "package-unit": "pkg.",
      "prepare-error": "Error preparing the plan. Check the client's Barsy configuration.",
      "re-export-hint": "The document has already been exported to Barsy. You can try exporting it again as a new load.",
      "rematch": "Re-match with AI",
      "show-attachments": "Show the attached files",
      "title": "Export Document No. {{number}} to Barsy",
      "toast": {
        "clear-error": "Error removing the link: {{message}}",
        "cleared": "The link to the Barsy store load was removed — the document can be exported as a new load.",
        "execute-error": "Error exporting: {{message}}",
        "executed": "The document was exported to Barsy (ID {{id}}).",
        "rematch-error": "Error re-matching: {{message}}",
        "rematched": "The matching was updated.",
        "save-error": "Error saving: {{message}}",
        "saved": "The export was saved.",
        "venue-changed": "The venue was changed.",
        "venue-changed-rematched": "The venue was changed and the articles were re-matched against its catalog.",
        "venue-error": "Error changing the venue: {{message}}"
      },
      "unit-prices-are": "Unit Prices Are",
      "vat-excl": "Excl. VAT",
      "vat-incl": "Incl. VAT",
      "vat-registered": "VAT Registration",
      "venue-change-message": "Venue “{{name}}” uses a different catalog — the selected articles will be cleared and the matching will be redone.",
      "venue-change-title": "Change of Venue",
      "venue-label": "Barsy Venue",
      "venue-placeholder": "Select a venue…"
    },
    "form": {
      "create": "Create in Barsy",
      "name": "Name",
      "no-venue": "No Barsy venue is selected."
    },
    "match": {
      "confidence": "Confidence: {{percent}}%",
      "good": "Good Match",
      "manual": "Manual Choice",
      "none": "No Match",
      "partial": "Partial Match",
      "suggestion-tooltip": "Suggestion: <Name/> (ID {{id}})"
    },
    "open-in-barsy": "Open in Barsy",
    "picker": {
      "article-label": "Barsy Article",
      "article-placeholder": "Select a Barsy article",
      "supplier-label": "Barsy Supplier",
      "supplier-placeholder": "Select a Barsy supplier"
    },
    "supplier-fallback": "Supplier #{{id}}",
    "supplier-form": {
      "create-title": "New Supplier in Barsy",
      "mol": "Accountable Person (MOL)",
      "toast": {
        "create-error": "Error creating the supplier: {{message}}",
        "created": "The supplier was created in Barsy (ID {{id}})."
      },
      "vat-number": "VAT No."
    }
  },
  "bo": {
    "form": {
      "new-title": "New Agent",
      "new-title-named": "New Agent: <Name/>"
    },
    "list": {
      "add": "Add New Agent",
      "edit-tooltip": "Edit agent",
      "title": "Support Agents"
    },
    "role": {
      "admin": "Administrator",
      "helpdesk": "Helpdesk",
      "sales": "Sales Representative"
    }
  },
  "broadcast": {
    "delete-message": "Are you sure you want to delete the notification <Subject/>?",
    "delete-note": "The notification will be removed from the employees' notification list",
    "delete-title": "<mark>Delete</mark> Notification",
    "delete-toast": "Notification {{subject}} was deleted successfully",
    "form": {
      "create-title": "Create a New Notification",
      "edit-title": "Edit Notification {{subject}}",
      "recipients-required": "Add at least one recipient",
      "save-draft": "Save as Draft",
      "save-error": "Error saving the notification: {{message}}. Please try again",
      "subject-placeholder": "What is the notification about"
    },
    "list": {
      "add": "New Notification",
      "delete-tooltip": "Delete notification <Subject/>",
      "edit-tooltip": "Edit notification <Subject/>",
      "send-tooltip": "Send the notification <Subject/>",
      "title": "Sent Notifications",
      "view-tooltip": "View notification <Subject/>"
    },
    "recipients": {
      "no-location": "No location",
      "title": "Select Employees"
    },
    "send-message_one": "Are you sure you want to send the notification <Subject/> to <strong>{{count}} recipient</strong>?",
    "send-message_other": "Are you sure you want to send the notification <Subject/> to <strong>{{count}} recipients</strong>?",
    "send-title": "<mark>Send</mark> Notification",
    "send-toast": "Notification {{subject}} was sent successfully",
    "state": {
      "draft": "Draft",
      "sent": "Sent"
    },
    "status": {
      "read-at": "Read At",
      "read-by": "Read by:",
      "recipients": "Recipients:",
      "signature": "Signature",
      "unread": "Unread"
    }
  },
  "client": {
    "access": {
      "disable-menu-tooltip": "The selected clients' access will be terminated",
      "disable-message": "Are you sure you want to disable the following clients:",
      "disable-title": "Disable Clients",
      "disable-toast-errors": "Errors while disabling: {{errors}}",
      "disable-toast-success_one": "Disabled {{count}} client",
      "disable-toast-success_other": "Disabled {{count}} clients",
      "disable-toast-title": "Result of disabling the selected clients",
      "enable-menu-tooltip": "The selected clients' access will be restored",
      "enable-message": "Are you sure you want to enable the following clients:",
      "enable-title": "Enable Clients",
      "enable-toast-errors": "Errors while enabling: {{errors}}",
      "enable-toast-success_one": "Enabled {{count}} client",
      "enable-toast-success_other": "Enabled {{count}} clients",
      "enable-toast-title": "Result of enabling the selected clients"
    },
    "column": {
      "cloud-storage": "Cloud Storage",
      "contracted-users": "Contracted Users",
      "expires-at": "Expires On",
      "features": "Features",
      "next-payment": "Next Payment"
    },
    "feature": {
      "barsy-export": "Barsy Export",
      "control-card": "Control Cards",
      "course": "Training",
      "incoming-control": "Purchase Records",
      "organizer": "Organizer",
      "sms-notification": "SMS Notifications",
      "ticket": "Tickets"
    },
    "form": {
      "clear-date": "Clear",
      "company-name": "Company Name",
      "contacts": "Contacts",
      "contract-end": "Contract End",
      "contract-end-placeholder": "e.g. 24.12.2022",
      "create-success": "Successfully created {{name}}",
      "due-dates": "Due Dates",
      "ext-link": "External Dossier",
      "ext-link-open": "Open the link",
      "feature-disable-confirm": "Are you sure you want to deactivate the \"{{feature}}\" feature?",
      "feature-disable-title": "Deactivating a Feature",
      "features-label": "Enabled Features",
      "mol": "Accountable Person (MOL)",
      "new-title": "New Client",
      "new-title-named": "New Client: <Name/>",
      "next-invoice": "Make Next Invoice",
      "next-invoice-label": "Next Invoice",
      "offset-months_one": "+ {{count}} month",
      "offset-months_other": "+ {{count}} months",
      "offset-year": "+ 1 year",
      "payment-plan": "Payment Plan",
      "quick-dates": "Quick Dates",
      "rel-previous": "Relative to Previous Due Date",
      "rel-today": "Relative to Today",
      "tab": {
        "dossier": "Dossier",
        "features": "Features",
        "levels": "Employees and Levels"
      },
      "today": "Today",
      "update-success": "Successfully updated {{name}}",
      "vat": "VAT No."
    },
    "level": {
      "add": "Add",
      "column": {
        "current": "Current Employees",
        "level": "Level",
        "limit": "Employee Limit"
      },
      "delete-confirm-message": "Are you sure you want to delete the level {{level}} ({{seats}})?",
      "delete-confirm-title": "Deleting a Level",
      "delete-error": "Error deleting level {{level}} ({{seats}})",
      "delete-success": "Successfully deleted level {{level}} ({{seats}})",
      "dialog-title": "Employee Count: {{name}}",
      "max-seats": "Contracted Users",
      "save-error": "Error saving level {{level}} ({{seats}})",
      "save-success": "Successfully saved level {{level}} ({{seats}})",
      "seats_one": "{{count}} employee",
      "seats_other": "{{count}} employees"
    },
    "list": {
      "add": "Add New Client",
      "edit-tooltip": "Edit client",
      "export": "Export",
      "export-tooltip": "The export contains only the results on the current page. Increase the page size for a complete export.",
      "ext-link": "Open the external dossier:",
      "impersonate": "Log in as the client",
      "seats_one": "{{count}} employee",
      "seats_other": "{{count}} employees",
      "title": "Clients"
    },
    "payment-plan": {
      "annual": "Annual",
      "bi-monthly": "Bi-monthly",
      "fifty-fifty": "50/50",
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "semi-annual": "Semi-annual"
    },
    "search": {
      "expires-from": "Expires From",
      "expires-to": "Expires To",
      "next-payment-from": "Next Payment From",
      "next-payment-to": "Next Payment To"
    },
    "storage": {
      "archived": "Archived (deleted):",
      "by-type-heading": "By type:",
      "extra": "Extra space:",
      "files_one": "{{count}} file",
      "files_other": "{{count}} files",
      "title": "Cloud Storage of \"{{name}}\"",
      "total": "Total used:",
      "total-heading": "Total:",
      "type": {
        "control-card-instance": "Control Cards",
        "incoming-document": "Purchase Records",
        "organizer-document": "Organizer",
        "other": "Other"
      },
      "uploaded": "Uploaded by the client:"
    }
  },
  "common": {
    "access-blocked": "Access is blocked",
    "access-level": "Access Level",
    "action": {
      "delete": "Delete",
      "edit": "Edit",
      "view": "View"
    },
    "action-error": "Error performing the action",
    "address": "Address",
    "attachments": {
      "add-file": "Add File",
      "documents-title": "Attached Documents ({{files}}):",
      "download-pdf": "Download PDF",
      "empty": "No attached files",
      "remove-tooltip": "Remove <Name/>",
      "share": "Share",
      "state-error": "Upload Error",
      "state-pending": "Pending",
      "state-uploaded": "Uploaded",
      "state-uploading": "Uploading",
      "uploading": "Uploading... ({{percent}})",
      "view-title": "Attached Files ({{files}})"
    },
    "button": {
      "back": "Back",
      "clear": "Clear",
      "create": "Create",
      "remove": "Remove",
      "save": "Save",
      "send": "Send"
    },
    "column": {
      "actions": "Actions",
      "created-at": "Created At",
      "from": "From",
      "name": "Name",
      "position": "Position",
      "updated-at": "Updated At"
    },
    "combo-box": {
      "clear-search": "Clear search",
      "clear-selection": "Clear selection",
      "no-matches": "No matches",
      "show-options": "Show options"
    },
    "content": "Content",
    "date-picker": {
      "manual-entry-placeholder": "Enter a date in the DD/MM/YYYY format"
    },
    "day-duration": {
      "days_one": "{{count}} day",
      "days_other": "{{count}} days"
    },
    "description": "Description",
    "dialog": {
      "cancel": "Cancel",
      "close": "Close",
      "confirm": "Confirm",
      "move": "Move"
    },
    "eik": "EIK",
    "email": "Email",
    "error-page": {
      "message": "Error loading the application. Please try again in a few seconds",
      "retry": "Try Again"
    },
    "fallback": {
      "reload": "Reload",
      "title": "Internal application error"
    },
    "feature-disabled": {
      "contact": "You can request this service by phone <Phone/> or by email <Email/>.",
      "organizer": "The electronic organizer lets you store important documents for this location, accessible at any time. You can create email or SMS reminders for when a document's term expires. The documents are also accessible to the employees at these locations if you give them the corresponding permissions.",
      "sms": "SMS notifications allow sending SMS messages in addition to email or in-app notifications. This way you can be sure you will receive the important notifications without having to open the application or check your email.",
      "title": "Inactive Feature"
    },
    "footer": {
      "copyright": "© 2026 Еф Ес Академи ООД ⋅",
      "privacy-policy": "Privacy Policy"
    },
    "form": {
      "default-language": "Default Language",
      "document-save-error": "Error saving the document: {{message}}. Please try again",
      "edit-title": "Editing <Name/>",
      "name-placeholder": "Please enter a name",
      "no-language": "No default language",
      "password-description": "Leave empty if you don't want to change it",
      "recipients": "Recipients ({{recipients}})",
      "recipients-empty": "Select recipients",
      "repeat-password": "Repeat Password",
      "save-failed": "Saving failed"
    },
    "input": {
      "enter-number": "Enter a number",
      "enter-time": "Enter a time in HH:MM format",
      "enter-value": "Enter a value"
    },
    "language": "Language",
    "loading": "Loading, please wait…",
    "location": "Location",
    "locations": "Locations",
    "menu": {
      "archive-selected": "Archive the Selected",
      "disable-selected": "Disable the Selected",
      "enable-selected": "Enable the Selected",
      "restore-selected": "Restore the Selected"
    },
    "not-found": "This page does not exist or you do not have access to it.",
    "notes": "Notes",
    "option": {
      "active": "Active",
      "active-and-inactive": "Active and Inactive",
      "all": "All"
    },
    "organizer": "Organizer",
    "paging": {
      "all": "All",
      "next-page": "Next page",
      "no-next-page": "No more pages",
      "no-prev-page": "No previous page",
      "no-results": "No results found",
      "page-of": "Page <strong>{{number}}</strong> of <strong>{{total}}</strong>",
      "per-page": "{{size}} per Page",
      "prev-page": "Previous page",
      "showing": "Showing <strong>{{from}}</strong> - <strong>{{to}}</strong> of <strong>{{total}}</strong> results at"
    },
    "password": "Password",
    "phone": "Phone",
    "plan": {
      "full": "Induction",
      "refresh": "Refresher"
    },
    "print-dialog": {
      "export-barsy": "Export to Barsy",
      "export-excel": "Export as Excel",
      "export-pdf": "Export as PDF",
      "print": "Print"
    },
    "recipients": {
      "select": "Select ({{recipients}})"
    },
    "review": {
      "label": "Review",
      "pending": "Pending Review",
      "reviewed": "Already Reviewed",
      "toolbar": "Review …"
    },
    "rte": {
      "align-center": "Center",
      "align-left": "Align left",
      "align-right": "Align right",
      "bold": "Bold",
      "bulleted-list": "Bulleted list",
      "clear-formatting": "Clear formatting",
      "font-decrease": "Smaller text",
      "font-increase": "Larger text",
      "heading": "Heading {{level}}",
      "highlight": "Highlighter",
      "indent-decrease": "Decrease indent",
      "indent-increase": "Increase indent",
      "italic": "Italic",
      "line-break": "Line break",
      "numbered-list": "Numbered list",
      "paragraph": "Text",
      "styles": "Styles",
      "underline": "Underline"
    },
    "search": {
      "label": "Search",
      "submit": "Search"
    },
    "status": "Status",
    "subject": "Subject",
    "supplier": "Supplier",
    "toolbar": {
      "access": "Access …"
    },
    "type": "Type",
    "validation": {
      "name-required": "The name is required",
      "required": "Required"
    },
    "version": {
      "client": "Client",
      "server": "Server"
    }
  },
  "control-card": {
    "category": {
      "daily": "Daily",
      "nested": "Nested",
      "recurring": "Recurring"
    },
    "combo-box": {
      "add-list": "Add New List",
      "add-title": "New Option List",
      "create": "Create",
      "edit-title": "Edit List",
      "edit-tooltip": "Edit the options",
      "key": "Key",
      "key-placeholder": "Unique identifier",
      "key-required": "The key is required",
      "name-placeholder": "Descriptive name",
      "options-hint": "Options — one per line. Empty lines, extra spaces, and duplicate values are removed automatically on save.",
      "saving": "Saving...",
      "search-placeholder": "Search by name or key",
      "title": "Combo Box Options",
      "toast-created": "The list \"{{name}}\" was created",
      "toast-saved": "The list \"{{name}}\" was saved"
    },
    "delete-instances": {
      "confirmation_one": "Are you sure you want to <strong>delete</strong> the following <strong>{{count}}</strong> control card?",
      "confirmation_other": "Are you sure you want to <strong>delete</strong> the following <strong>{{count}}</strong> control cards?",
      "title": "<mark>Deleting</mark> Control Cards",
      "toast-title": "Result of deleting the selected control cards"
    },
    "delete-template": {
      "confirmation": "<p>Deleting the template <strong>does not remove</strong> existing control cards.</p><p>Are you sure you want to delete the template <Name/>?</p>",
      "title": "Deleting a <mark>Template</mark>",
      "toast-success_one": "Deleted {{count}} template",
      "toast-success_other": "Deleted {{count}} templates",
      "toast-title": "Result of deleting the selected control card templates"
    },
    "delete-template-instances": {
      "confirmation": "<p>Are you sure you want to delete <strong>all</strong> control cards created from the template <Name/>?</p>",
      "title": "Deleting the <mark>Control Cards</mark>",
      "toast-title": "Result of deleting the control cards for template {{name}}"
    },
    "editor": {
      "add-column": "Add Column",
      "block-edit-title": "Editing {{label}}",
      "card-type": {
        "ad-hoc": "Without Schedule",
        "nested": "Nested",
        "recurring": "With Schedule and Deadline Support"
      },
      "choice": {
        "add-option": "Add Option",
        "comment-fallback": "Коментар",
        "comment-label": "Comment Field Label",
        "comment-label-hint": "If left empty, the label is \"Коментар\"",
        "comment-label-view": "(Comment label: <Value/>)",
        "delete-confirm": "Are you sure you want to delete option \"{{text}}\"?",
        "delete-title": "Delete Option \"{{text}}\"",
        "edit-title": "Editing Option \"{{text}}\"",
        "key-tooltip": "Key: <Key/>",
        "new-title": "New Option",
        "no-options": "No options added"
      },
      "choice-type": {
        "single": "Choice",
        "with-comment": "Choice with Comment"
      },
      "collapse": "Collapse",
      "column": {
        "add-tooltip": "Add a new column after <Name/>",
        "boundary": "Minimum and Maximum Value Range",
        "boundary-hint": "If set, the user will not be able to enter or select values outside this range.",
        "choice-options": "Choice Options",
        "copy-tooltip": "Create a new column using <Name/> as a base",
        "default-value": "Default Value",
        "default-value-hint": "This is the value that will be <strong>filled in</strong> automatically when the control card is created",
        "default-value-of": "Default Value of Column \"{{title}}\"",
        "delete-confirm": "Are you sure you want to delete column \"{{title}}\"?",
        "delete-title": "Delete Column \"{{title}}\"",
        "delete-tooltip": "Delete <Name/>",
        "description-hint": "Additional explanatory text to help the user when filling in this value",
        "edit-title": "Editing Column \"{{title}}\"",
        "edit-tooltip": "Edit <Name/>",
        "employee-groups": "Employee Groups",
        "employee-groups-hint": "If at least one group is selected, the employee picker will show only the people from these groups.",
        "expression": "Value Formula",
        "expression-hint": "This formula calculates the column's value",
        "green-zone": "\"Green Zone\" Range",
        "green-zone-hint": "If set, values within the selected range will be colored green, and values outside it - red.",
        "group-archived": "{{name}} (archived)",
        "groups-all": "All",
        "icon-set": "Icons for Increasing and Decreasing the Number",
        "initial-value": "Initial Value",
        "initial-value-hint": "This is the value that will be <strong>suggested</strong> to the user",
        "initial-value-of": "Initial Value of Column \"{{title}}\"",
        "input-method": "Input Method",
        "key": "Key",
        "key-required": "The key is required",
        "list-key": "List Key",
        "lock-tooltip": "When the primary column is marked as locked, it cannot be edited in the control card. This column can be selected <Em>only</Em> when adding a new record.",
        "locked": "Locked",
        "make-primary-tooltip": "Make <Name/> the primary column",
        "move-down-tooltip": "Move <Name/> down",
        "move-up-tooltip": "Move <Name/> up",
        "must-select-icons": "Select icons",
        "must-select-input-method": "Select an input method",
        "must-select-list-key": "Select a list key",
        "must-select-nested": "Select a nested card",
        "new-title": "New Column",
        "no": "No",
        "no-expression": "No formula",
        "no-initial-value": "No initial value",
        "no-range": "No range",
        "no-unit": "No Unit",
        "open-camera": "Open the Camera Directly",
        "open-camera-hint": "When uploading from a phone, the camera opens directly, without a file picker dialog. Only photos can be uploaded.",
        "options": "Options",
        "show-expression": "Show / Hide Formula",
        "show-expression-hint": "This formula calculates whether the column should be hidden or shown",
        "title-label": "Column Name",
        "unit": "Unit",
        "user-groups": "User Groups",
        "user-groups-hint": "If at least one group is selected, the ticket recipients will be filtered by these groups.",
        "validation": "Validation",
        "validation-hint": "The row cannot be completed if the value does not meet the conditions.",
        "yes": "Yes"
      },
      "column-type": {
        "attachment": "Photo",
        "choice": "Choice (Single)",
        "combo-box": "Text (with Suggestions)",
        "date": "Date",
        "employee-ref": "Employee",
        "label": "Label",
        "multi-choice": "Choice (Multiple)",
        "nested": "Nested Card",
        "number": "Number",
        "signature": "Signature",
        "text": "Text",
        "ticket": "Ticket",
        "time": "Time",
        "transposed": "Transposed"
      },
      "columns": "Columns",
      "definition": {
        "invalid-json": "Invalid JSON object: {{message}}",
        "label": "Template",
        "placeholder": "Please enter a template"
      },
      "expand": "Expand",
      "form": {
        "copy-rows": "Copy the Last Card When Creating on Schedule",
        "due-to": "Completion Deadline Within the Day",
        "dynamic-rows": "Adding or Removing Rows",
        "footer-text": "Help Text Below the Table",
        "header-text": "Help Text Above the Table",
        "help-text": "Help Text",
        "schedule": "Automatic Creation Schedule",
        "type": "Type"
      },
      "icon-set": {
        "number": "Minus / Plus",
        "temperature": "Cold / Hot"
      },
      "input-method": {
        "discrete": "Slider Input",
        "free": "Keyboard Input"
      },
      "kind": "Kind",
      "no-columns": "There are no columns in this template",
      "number-input": {
        "action-text": "Action Label",
        "action-text-hint": "This is the text shown on the button for slider input, or as explanatory text in the field for keyboard number input",
        "action-text-placeholder": "For example \"Изберете температура\", \"Въведете тегло\" or similar",
        "action-text-view": "Action label: <Value/>",
        "edit-title": "Editing the Number Input Method",
        "method-label": "Number Input Method",
        "range-required": "Select the slider's start and end",
        "slider-range": "Slider Start and End",
        "slider-range-hint": "The minimum and maximum value selectable with the slider",
        "step": "Step",
        "step-hint-discrete": "The interval between the slider's selectable options, and by how much the number increases and decreases when pressing the + and - buttons.",
        "step-hint-free": "By how much the number increases and decreases when pressing the + and - buttons.",
        "step-required": "Select a step"
      },
      "range": {
        "above": "above <Num/>",
        "below": "below <Num/>",
        "edit-title": "Editing a Range",
        "field-required": "This field is required",
        "from": "From",
        "none": "No range",
        "remove-tooltip": "Remove the range",
        "to": "To"
      },
      "range-type": {
        "closed": "From - To",
        "open-end": "From",
        "open-start": "To"
      },
      "template": {
        "base-group": "Base Templates",
        "cold-dish-temp": "Storage Temperature of a Cold Dish",
        "compliance": "Compliant / Non-compliant",
        "empty-ad-hoc": "Blank Card Without Schedule",
        "empty-recurring": "Blank Card with Schedule Support",
        "empty-transposed": "Blank Card with a Single Row",
        "expiry-check": "Expiry Date Check",
        "freezer": "Freezer",
        "fridge": "Refrigerator",
        "fridge-display": "Refrigerated Display Case",
        "hot-dish-temp": "Internal Temperature of a Hot Dish",
        "humidity": "Humidity",
        "hygiene": "Hygiene",
        "notes": "Notes",
        "transposed": "Transposed"
      },
      "validation": {
        "badge-absolute": "ABSOLUTELY Required",
        "badge-with-comment": "Required with Comment",
        "edit-title": "Editing Validation",
        "message-hint": "This is the text that will appear if no value is entered in this column.",
        "message-label": "Error Message",
        "message-required": "This field is required",
        "message-view": "Message: <Message/>",
        "none": "No Validation",
        "override-label": "Can It Be Overridden",
        "override-no": "No, the Field Is ABSOLUTELY Required",
        "override-yes": "Yes, the Employee Can Skip It with a COMMENT"
      },
      "validation-type": {
        "required": "Required Field"
      },
      "value": {
        "choice-options": "Available Options",
        "comment-for-option": "{{label}} (for option {{option}}): ",
        "edit-title": "Editing {{label}}",
        "employee-ref": "Employee [{{id}}]",
        "empty-text": "Empty text",
        "expression-result": "The formula's result",
        "field-required": "The field is required",
        "nested-auto-create": "Nested Card (Automatic Creation)",
        "nested-manual-create": "Nested Card (Manual Creation)",
        "no-selected-values": "No selected values",
        "no-value": "No value",
        "null-value": "No value",
        "options-required": "Create options before selecting a value",
        "photos-existing": "Photos ({{id}})",
        "photos-new": "Photos (new)"
      },
      "value-type": {
        "attachment": "Photo",
        "auto-create": "Automatic Creation",
        "choice": "Choice",
        "date": "Date",
        "employee-ref": "Employee Reference",
        "empty": "No Value",
        "expression": "Formula",
        "manual-create": "Manual Creation",
        "multi-choice": "Multiple Choice",
        "number": "Number",
        "rich-text": "Formatted Text",
        "signature": "Signature",
        "text": "Text",
        "time": "Time"
      }
    },
    "export-panel": {
      "cards_one": "{{count}} card",
      "cards_other": "{{count}} cards",
      "delete-aria": "Delete",
      "delete-confirmation": "Only <strong>the export</strong> and the PDF files it generated will be deleted. The control cards themselves <strong>remain unchanged</strong>. Continue?",
      "delete-title": "Delete Export",
      "delete-tooltip": "Delete the export and its generated files",
      "duration-tooltip": "Export duration: {{duration}}",
      "estimated-end": "estimated end: <Ts/>",
      "no-recent": "No recent exports.",
      "retention-note": "Finished exports are available for download for 30 days after creation, after which they are deleted automatically.",
      "status": {
        "deleting": "Deleting",
        "done": "Ready",
        "failed": "Failed",
        "queued": "Queued",
        "running": "Generating",
        "stopped": "Stopped",
        "stopping": "Stopping"
      },
      "stop-aria": "Stop",
      "stop-confirmation": "The PDF file generation will be <strong>aborted</strong>. A stopped export <strong>cannot be resumed</strong>. Continue?",
      "stop-title": "Stop Export",
      "stop-tooltip": "Stop the export",
      "title": "Control Card Export"
    },
    "instance-list": {
      "column": {
        "date": "Date",
        "due-to": "Deadline",
        "status": "Status"
      },
      "delete-tooltip": "Delete this control card",
      "edit-template-tooltip": "Edit this card's template",
      "export": {
        "all-results": "For All Results",
        "all-results-title": "All control cards matching the current filter will be generated as PDF files in a ZIP archive",
        "confirm-all-filtered": "An export of <strong>all cards matching the current filter</strong> will be started as PDF files in a ZIP archive. Continue?",
        "confirm-month": "An export of <strong>all</strong> control cards for <Month/> will be started as PDF files in a ZIP archive. Continue?",
        "confirm-selected_one": "An export of <strong>{{count}}</strong> control card will be started as a PDF file in a ZIP archive. Continue?",
        "confirm-selected_other": "An export of <strong>{{count}}</strong> control cards will be started as PDF files in a ZIP archive. Continue?",
        "create-section": "Create Export",
        "current-month": "For the Current Month",
        "current-month-title": "All control cards for the current month will be generated as PDF files in a ZIP archive",
        "dialog-title": "Control Card Export",
        "download-section": "Download Export",
        "previous-month": "For the Previous Month",
        "previous-month-title": "All control cards for the previous month will be generated as PDF files in a ZIP archive",
        "recent": "Recent Exports",
        "selected": "For the Selected {{suffix}}",
        "selected-title": "The selected control cards will be generated as PDF files in a ZIP archive"
      },
      "mark-na": {
        "mark-selected": "Mark the Selected as Not Applicable {{suffix}}",
        "mark-selected-title": "The selected control cards will be marked as not applicable for this day",
        "toast-errors": "Errors while marking: {{errors}}",
        "toast-success_one": "Marked {{count}} control card as not applicable",
        "toast-success_other": "Marked {{count}} control cards as not applicable",
        "toast-title": "Result of marking control cards as not applicable"
      },
      "print-tooltip": "Print this control card",
      "rebuild-tooltip": "Recreate this control card from the current template",
      "report": {
        "all": "All Inspections",
        "create-selected": "Create a New Inspection for the Selected {{suffix}}"
      },
      "review": {
        "mark-selected": "Mark the Selected as Reviewed {{suffix}}",
        "mark-selected-title": "The selected control cards will be marked as reviewed by you",
        "toast-errors": "Errors while reviewing: {{errors}}",
        "toast-success_one": "Reviewed {{count}} control card",
        "toast-success_other": "Reviewed {{count}} control cards",
        "toast-title": "Result of marking control cards as reviewed"
      },
      "status": {
        "completed": "Completed",
        "completed-tooltip": "By <Name/> on <Ts/>",
        "incomplete": "Incomplete",
        "not-applicable": "Not Applicable",
        "not-applicable-tooltip": "Marked by <Name/> on <Ts/> with reason <Reason/>",
        "past-due": "Past Due"
      },
      "template-missing-tooltip": "The template for this card no longer exists",
      "title": "Control Cards",
      "toolbar": {
        "delete": "Delete",
        "delete-tooltip_one": "Delete the selected <strong>{{count}}</strong> control card",
        "delete-tooltip_other": "Delete the selected <strong>{{count}}</strong> control cards",
        "export": "Export …",
        "export-tooltip": "Export the selected control cards as PDF files in a ZIP archive",
        "mark-na": "Mark as Not Applicable …",
        "mark-na-tooltip": "Mark the selected control cards as not applicable due to a non-working day at the location or for other reasons",
        "report": "Inspection",
        "report-tooltip": "Create an inspection"
      },
      "unmark-na": {
        "mark-selected": "Clear Not Applicable for the Selected {{suffix}}",
        "mark-selected-title": "The not-applicable status of the selected control cards will be cleared",
        "toast-errors": "Errors while clearing: {{errors}}",
        "toast-success_one": "Cleared the not-applicable status of {{count}} control card",
        "toast-success_other": "Cleared the not-applicable status of {{count}} control cards",
        "toast-title": "Result of clearing the not-applicable status of control cards"
      },
      "unreview": {
        "mark-selected": "Undo Review of the Selected {{suffix}}",
        "mark-selected-title": "The reviewed status of the selected control cards will be cleared",
        "toast-errors": "Errors while undoing: {{errors}}",
        "toast-success_one": "Undid review of {{count}} control card",
        "toast-success_other": "Undid review of {{count}} control cards",
        "toast-title": "Result of undoing the review of control cards"
      }
    },
    "mark-na-dialog": {
      "quick-reason-day-off": "Non-Working Day",
      "quick-reason-holiday": "Public Holiday",
      "quick-reason-not-applicable": "Not Applicable for This Day",
      "quick-reasons": "Common Reasons:",
      "reason": "Reason",
      "reason-required": "The reason is required",
      "submit": "Mark",
      "title": "Mark as Not Applicable"
    },
    "rebuild": {
      "confirmation": "Are you sure you want to rebuild the control card?",
      "title": "Rebuild Control Card",
      "toast-errors": "Errors while rebuilding: {{errors}}",
      "toast-success_one": "Rebuilt {{count}} control card",
      "toast-success_other": "Rebuilt {{count}} control cards",
      "toast-title": "Result of rebuilding the selected control cards"
    },
    "report": {
      "create": {
        "estimate-size": "Estimate Size",
        "prompt-label": "Inspection Criteria",
        "prompt-required": "The inspection criteria are required",
        "size": "Size:",
        "start": "Start",
        "title": "Create an Inspection",
        "unknown-size": "Unknown"
      },
      "details": {
        "status": "Status",
        "title": "Inspection #{{id}}"
      },
      "list": {
        "column": {
          "completed": "Completed",
          "details": "Details"
        },
        "export": "Export",
        "export-tooltip": "The export contains only the results on the current page. Increase the page size for a complete export.",
        "open": "Open",
        "title": "Inspection List"
      },
      "price": "Price",
      "price-tooltip": "{{usd}}, at {{rate}} per $1, model {{model}}",
      "prompt": "Prompt",
      "result": "Result",
      "status-completed": "Completed",
      "status-running": "Running"
    },
    "review-status": {
      "not-reviewed-tooltip": "Not reviewed",
      "reviewed-tooltip": "Reviewed by <Name/> on <Ts/>"
    },
    "search": {
      "all-categories": "All Categories",
      "category": "Category",
      "date-from": "From Date",
      "date-to": "To Date",
      "status": "Status",
      "status-any": "Any",
      "status-completed": "Completed",
      "status-incomplete": "Incomplete"
    },
    "template-form": {
      "back": "Back",
      "category-label": "Card Category",
      "client-templates": "Client Templates",
      "edit-title": "Editing <Name/> for Location <Location/>",
      "name-label": "Card Name",
      "new-template": "New Template",
      "new-title": "New Template for Location <Location/>",
      "new-title-named": "New Template: <Name/> for Location <Location/>",
      "save-error": "Error saving the template: {{message}}",
      "tab-code": "Code",
      "tab-editor": "Editor",
      "toast-saved": "Template {{name}} saved successfully",
      "validation-error": "Template validation error"
    },
    "template-list": {
      "add-template": "Add New Template",
      "column": {
        "category": "Category"
      },
      "combo-box-options": "Combo Box Options",
      "delete-instances-tooltip": "Delete all <strong>control cards</strong> created from this template",
      "delete-template-tooltip": "Delete this control card <strong>template</strong>",
      "edit-template-tooltip": "Edit the template",
      "title": "Control Card Templates for Location <Location/>"
    },
    "toast": {
      "delete-errors": "Errors while deleting: {{errors}}",
      "deleted-instances_one": "Deleted {{count}} control card",
      "deleted-instances_other": "Deleted {{count}} control cards"
    }
  },
  "employee": {
    "access-code": {
      "copied": "The code of <Name/> was copied successfully",
      "copy-failed": "Copying the code failed",
      "copy-tooltip": "Copy the code and short instructions"
    },
    "column": {
      "access-code": "Access Code",
      "completed": "Completed",
      "in-progress": "Current Course",
      "level": "Level"
    },
    "form": {
      "access-code-hint": "The access code is generated automatically after the employee is saved",
      "dob": "Date of Birth",
      "dob-description": "Not required — only if there are two or more employees <strong>with exactly matching names</strong>",
      "dob-placeholder": "e.g. 24/12/2012",
      "name-placeholder": "Please enter the employee's name",
      "new-title": "New Employee",
      "new-title-named": "New Employee: <Name/>",
      "no-level": "No training",
      "no-locations": "No locations",
      "no-position": "No position",
      "save-error": "Error saving the employee: {{message}}. Please try again",
      "save-success": "Employee {{name}} saved successfully"
    },
    "level": {
      "free-seats_one": "{{count}} free seat",
      "free-seats_other": "{{count}} free seats",
      "full-seats_one": "{{count}} seat taken",
      "full-seats_other": "All {{count}} seats taken",
      "occupied-seats": "{{occupied}} of {{total}} seats taken"
    },
    "level-label": "Training Level",
    "list": {
      "add": "Add New Employee",
      "change-level": "Change Level of the Selected …",
      "create-protocol": "Create Protocol …",
      "disable-hint": "The selected employees' access will be revoked and their seats will be freed for new ones",
      "disable-message_one": "Are you sure you want to disable the following employee:",
      "disable-message_other": "Are you sure you want to disable the following employees:",
      "disable-title": "Disable Employees",
      "disable-toast-errors": "Errors while disabling: {{errors}}",
      "disable-toast-success_one": "Disabled {{count}} employee",
      "disable-toast-success_other": "Disabled {{count}} employees",
      "disable-toast-title": "Result of disabling the selected employees",
      "edit-tooltip": "Edit the employee",
      "enable-hint": "The selected employees' access will be restored",
      "enable-message_one": "Are you sure you want to enable the following employee:",
      "enable-message_other": "Are you sure you want to enable the following employees:",
      "enable-title": "Enable Employees",
      "enable-toast-errors": "Errors while enabling: {{errors}}",
      "enable-toast-success_one": "Enabled {{count}} employee",
      "enable-toast-success_other": "Enabled {{count}} employees",
      "enable-toast-title": "Result of enabling the selected employees",
      "export": "Export",
      "export-tooltip": "The export contains only the results on the current page. Increase the page size for a complete export.",
      "level-change-message_one": "Are you sure you want to change the level of the following employee to <Name/>:",
      "level-change-message_other": "Are you sure you want to change the level of the following employees to <Name/>:",
      "level-change-title": "Change Employee Level",
      "level-change-toast-errors": "Errors while changing the level: {{errors}}",
      "level-change-toast-success_one": "Changed the level of {{count}} employee",
      "level-change-toast-success_other": "Changed the level of {{count}} employees",
      "level-change-toast-title": "Result of changing the level of the selected employees",
      "login-as-tooltip": "Log in as this employee",
      "no-level": "No level",
      "no-level-inline": "no level",
      "no-location": "No location",
      "no-position": "No position",
      "title": "Employees"
    },
    "permission": {
      "add-inc-doc": "Add Documents",
      "edit-control-card": "Fill In Control Cards",
      "edit-organizer": "Edit Organizer",
      "edit-other-inc-doc": "Edit Other Employees' Documents",
      "edit-own-inc-doc": "Edit Own Documents",
      "group": {
        "control-card": "Control Cards",
        "inc-doc": "Purchase Records"
      },
      "help": {
        "add-inc-doc": "The employee will be able to <strong>add documents</strong> to Purchase Records for this location.",
        "edit-control-card": "The employee will be able to <strong>create or fill in already created</strong> control cards — from <strong>today and the selected number of days back</strong>. With “0 days” only today's cards can be filled in. Older control cards will not be editable.",
        "edit-organizer": "The employee will be able to <strong>add, edit and delete</strong> documents in the organizer for this location.",
        "edit-other-inc-doc": "The employee will be able to edit <strong>documents created by other employees</strong> in Purchase Records — from <strong>today and the selected number of days back</strong>. With “0 days” only today's documents can be edited. Older documents will not be editable.",
        "edit-own-inc-doc": "The employee will be able to edit <strong>their own documents</strong> in Purchase Records — from <strong>today and the selected number of days back</strong>. With “0 days” only today's documents can be edited. Older documents will not be editable.",
        "view-control-card": "The employee will have access to <strong>control cards</strong> for this location.",
        "view-inc-doc": "The employee will have access to <strong>Purchase Records</strong> for this location.",
        "view-organizer": "The employee will have access to <strong>the organizer</strong> for this location."
      },
      "no-limit": "No limit",
      "time-limit": "up to <Input/> back",
      "title": "Access Permissions",
      "tooltip-no-limit": "(no limit)",
      "tooltip-time-limit": "(up to <Dur/> back)",
      "tooltip-today-only": "(current day only)",
      "view-control-card": "Access to \"Control Cards\"",
      "view-inc-doc": "Access to \"Purchase Records\"",
      "view-organizer": "Access to \"Organizer\""
    },
    "plan": {
      "refresh": "Refresher ({{from}} - {{to}})"
    },
    "progress": {
      "completed-at": "Completed on <Date/> with an average score of {{score}}",
      "last-answer": "The last answer was given on <Ts/>",
      "lesson-completed-at": "Completed on <Date/> with a score of {{score}}.",
      "lesson-started-at": "Started on <Date/>",
      "lessons-progress_one": "{{completed}} of {{count}} topic completed ({{percent}}) with average score {{score}}",
      "lessons-progress_other": "{{completed}} of {{count}} topics completed ({{percent}}) with average score {{score}}",
      "no-current": "There is no current course",
      "overdue_one": "Overdue by <strong>{{count}} day</strong>",
      "overdue_other": "Overdue by <strong>{{count}} days</strong>",
      "period": "(period from <From/> to <To/>)",
      "required-question-failed": "A required question was answered incorrectly",
      "test-not-submitted_one": "The test has not been submitted. {{answered}} of {{count}} question answered, of which {{correct}} is correct.",
      "test-not-submitted_other": "The test has not been submitted. {{answered}} of {{count}} questions answered, of which {{correct}} are correct.",
      "test-result": "Current test score {{current}} with a minimum of {{min}}.",
      "watched": "Watched {{percent}}"
    },
    "protocol": {
      "all-results": "For All Results",
      "all-results-hint": "For all employees matching the current filters",
      "current-page": "For the Current Page",
      "current-page-hint": "Only for the employees on the current page",
      "header": "Protocol",
      "include-plans-header": "Include the Following Courses",
      "selected": "Only for the Selected {{suffix}}",
      "selected-hint": "Only for the selected employees on the current page"
    },
    "search": {
      "access": "Access",
      "completed-from": "Completion Date From",
      "completed-to": "Completion Date To"
    }
  },
  "incdoc": {
    "barsy-status": {
      "exported": "Exported to Barsy on <Ts/>",
      "not-exported": "Not exported to Barsy"
    },
    "form": {
      "add-title": "Add Document",
      "ai-no-results": "Not Recognized with AI",
      "ai-results": "Recognized with AI",
      "date": "Document Date",
      "date-placeholder": "Enter the document date",
      "edit-supplier": "Edit {{name}}",
      "edit-title": "Edit Document {{number}}",
      "fill-with-ai": "Fill with AI",
      "location-placeholder": "Select the location this document is for",
      "mark-reviewed": "Mark as Reviewed",
      "new-supplier": "New Supplier",
      "notes-placeholder": "Additional notes (if needed)",
      "number": "Document Number",
      "number-placeholder": "Enter the document number",
      "supplier-placeholder": "Select the supplier who issued the document"
    },
    "list": {
      "add-document": "Add New Document",
      "ai-dialog-title": "AI Recognition",
      "ai-preview-tooltip": "View the AI result for document #<Num/>",
      "ai-schedule-tooltip": "Recognize document #<Num/> with AI",
      "ai-scheduled": "AI recognition of document #<Num/> has been scheduled.<br/>Expected time: <Ts/>",
      "column": {
        "created-by": "Created By",
        "date": "Date",
        "export": "Export",
        "files": "Files",
        "number": "Number",
        "supplier": "Supplier"
      },
      "delete-confirmation": "Are you sure you want to delete document <Num/>",
      "delete-title": "<mark>Deleting</mark> a Document",
      "delete-toast": "Document #{{number}} was deleted successfully",
      "delete-tooltip": "Delete document #<Num/>",
      "download-pdf-tooltip": "Download document #<Num/> as PDF",
      "edit-tooltip": "Edit document #<Num/>",
      "review": {
        "mark-selected": "Mark the Selected as Reviewed {{suffix}}",
        "mark-selected-title": "The selected documents will be marked as reviewed by you",
        "toast-errors": "Errors while reviewing: {{errors}}",
        "toast-success_one": "Reviewed {{count}} document",
        "toast-success_other": "Reviewed {{count}} documents",
        "toast-title": "Result of marking documents as reviewed"
      },
      "unreview": {
        "mark-selected": "Undo Review of the Selected {{suffix}}",
        "mark-selected-title": "The reviewed status of the selected documents will be cleared",
        "toast-errors": "Errors while undoing: {{errors}}",
        "toast-success_one": "Undid review of {{count}} document",
        "toast-success_other": "Undid review of {{count}} documents",
        "toast-title": "Result of undoing the review of documents"
      },
      "view-files": "View ({{files}})"
    },
    "ocr": {
      "apply-selected": "Fill In the Selected",
      "badge-existing": "Existing",
      "badge-new": "New",
      "create-new": "Create New: {{name}}",
      "document-date": "Document Date: <Dt/>",
      "document-number": "Document Number: <Num/>",
      "no-results-text": "We could not recognize any data from the documents. Please take a clearer photo — make sure there is enough light and the entire document is visible in the frame.",
      "no-results-title": "The documents were not recognized with AI",
      "supplier": "Supplier: <Name/>",
      "title": "Verify the recognized attributes against the document",
      "use-existing": "Use Existing: {{name}}"
    },
    "search": {
      "created-from": "Creation Date From",
      "created-to": "Creation Date To",
      "doc-date-from": "Document Date From",
      "doc-date-to": "Document Date To",
      "suppliers": "Suppliers"
    },
    "supplier": {
      "add-title": "Add Supplier",
      "edit-title": "Edit Supplier {{name}}",
      "eik-placeholder": "Enter the supplier's EIK",
      "name": "Supplier Name",
      "name-placeholder": "Enter the supplier's name"
    }
  },
  "level": {
    "column": {
      "video-lessons": "Video Lessons in Level"
    },
    "form": {
      "new-title": "New Level",
      "new-title-named": "New Level: <Name/>",
      "video-lessons": "Selected Topics"
    },
    "list": {
      "add": "Add New Level",
      "edit-tooltip": "Edit level",
      "title": "Levels"
    }
  },
  "location": {
    "archive": {
      "intro_one": "Archive the following location:",
      "intro_other": "Archive the following {{count}} locations:",
      "keeps-control-cards": "All control card templates, as well as the already filled-in control cards",
      "keeps-incdoc": "All documents from Purchase Records",
      "keeps-lead": "Archiving <strong>keeps</strong> the following, but makes them inaccessible until the location is restored:",
      "keeps-organizer": "The location's organizer",
      "question": "Are you sure you want to archive the selected locations?",
      "removes-lead": "Archiving <strong>removes</strong> the following, and they <strong>cannot be restored</strong>:",
      "removes-memberships": "The assignment of employees and managers to the location. The employees and managers themselves are kept",
      "removes-permissions": "All employee permissions for the location",
      "stops-lead": "Archiving <strong>stops</strong> the following until the location is restored:",
      "stops-notifications": "All notifications on every notification channel (email, SMS and in-app)",
      "stops-scheduled-cards": "The creation of the daily and periodic scheduled control cards",
      "title": "Archive Locations",
      "toast-errors": "Errors while archiving: {{errors}}",
      "toast-success_one": "Archived {{count}} location",
      "toast-success_other": "Archived {{count}} locations",
      "toast-title": "Result of archiving the selected locations"
    },
    "column": {
      "control-cards": "Control Cards"
    },
    "form": {
      "address-placeholder": "Please enter an address",
      "new-title": "New Location",
      "new-title-named": "New Location: <Name/>",
      "save-error": "Error saving the location: {{message}}. Please try again",
      "save-success": "Location {{name}} saved successfully"
    },
    "list": {
      "add": "Add New Location",
      "archive-hint": "The selected locations will be archived",
      "archived-tooltip": "The location is archived",
      "create-organizer": "Create Organizer",
      "edit-tooltip": "Edit the location",
      "no-templates": "None",
      "restore-hint": "The selected locations will be restored",
      "templates-tooltip": "Control card templates"
    },
    "restore": {
      "intro_one": "Restore the following location:",
      "intro_other": "Restore the following {{count}} locations:",
      "manual-note": "<strong>They must be restored manually.</strong>",
      "not-restored-lead": "Restoring the location <strong>does not restore</strong> the following links:",
      "not-restored-memberships": "The assignment of employees and managers to the location",
      "not-restored-permissions": "The employee permissions for the location",
      "question": "Are you sure you want to restore the selected locations?",
      "restores-control-cards": "Access to the control cards filled in before the location was archived",
      "restores-incdoc": "Access to all documents from Purchase Records",
      "restores-lead": "The following is restored:",
      "restores-notifications": "Notifications resume on every notification channel (email, SMS and in-app)",
      "restores-organizer": "Access to the location's organizer",
      "restores-scheduled-cards": "The creation of the daily and periodic scheduled control cards resumes",
      "title": "Restore Locations",
      "toast-errors": "Errors while restoring: {{errors}}",
      "toast-success_one": "Restored {{count}} location",
      "toast-success_other": "Restored {{count}} locations",
      "toast-title": "Result of restoring the selected locations"
    },
    "search": {
      "only-archived": "Only Archived"
    }
  },
  "login": {
    "bo-failed": "Unsuccessful login. Please try again",
    "bo-title": "FSAcademy Administration Login",
    "disabled-bo": "Log In as Another Administrator",
    "disabled-manager": "Log In as Another Manager",
    "disabled-title": "Your access has been deactivated",
    "forgot-instructions": "Enter the email you use to log in. You will receive a message with a link that lets you log in to your account directly.",
    "forgot-link": "Forgot Password",
    "forgot-success": "If there is an account registered with <strong>{{email}}</strong>, you will receive an email with instructions. Check <strong>your inbox</strong> as well as the <strong>Spam</strong> folder.",
    "invalid-email": "Enter a valid email address",
    "manager-failed": "Unsuccessful login. Please make sure the email and password are entered correctly and try again.",
    "manager-title": "Administrative access for <strong>managers</strong> in FSAcademy",
    "password-login-link": "Login with Password",
    "privacy-login": "By pressing the <strong>Login</strong> button you agree with the <PrivacyLink>privacy policy</PrivacyLink>",
    "privacy-send": "By pressing the <strong>Send</strong> button you agree with the <PrivacyLink>privacy policy</PrivacyLink>",
    "send": "Send",
    "start-over": "Start Over",
    "submit": "Login",
    "success-toast": "Successful login"
  },
  "manager": {
    "all-locations": "All locations",
    "column": {
      "login": "Login"
    },
    "form": {
      "admin-only-warning": "Only a <strong>manager</strong> with access level <strong>Administrator</strong> can edit <strong>Access Level</strong> and <strong>Locations</strong>.",
      "email-notification": "Use This Email for Notifications",
      "invalid-email": "Invalid email",
      "locations-required": "Select at least one location",
      "new-title": "New Manager",
      "new-title-named": "New Manager: <Name/>",
      "no-locations-selected": "No locations selected",
      "password-copied": "The new password was copied to the clipboard",
      "password-min": "The password must be at least 8 characters",
      "password-required": "The password is required",
      "passwords-mismatch": "The passwords do not match",
      "phone-notification": "Use This Phone for Notifications",
      "save-error": "Error saving the manager: {{message}}. Please try again",
      "suggest-password": "Suggest a Strong Password"
    },
    "list": {
      "add": "Add Manager",
      "disable-hint": "The selected managers' access will be revoked",
      "disable-message_one": "Are you sure you want to disable the following manager:",
      "disable-message_other": "Are you sure you want to disable the following managers:",
      "disable-title": "Disable Managers",
      "edit-tooltip": "Edit the manager",
      "enable-hint": "The selected managers' access will be restored",
      "enable-message_one": "Are you sure you want to enable the following manager:",
      "enable-message_other": "Are you sure you want to enable the following managers:",
      "enable-title": "Enable Managers",
      "login-as-tooltip": "Log in as this manager",
      "login-email-message": "Are you sure you want to send a login email to {{name}}?",
      "login-email-title": "Send Login Email",
      "login-email-toast": "The login email was sent",
      "no-locations": "No locations",
      "send-login-email-tooltip": "Send a login email to <Name/>",
      "test-send-message": "Are you sure you want to send a test message to {{name}}?",
      "test-send-title": "Send Test Message",
      "test-send-toast": "The test message was sent successfully",
      "test-send-tooltip": "Send a test message on all active channels",
      "title": "Managers"
    },
    "role": {
      "admin": "Administrator",
      "manager": "Selected Locations"
    }
  },
  "nav": {
    "admin": {
      "clients": "Clients",
      "features": {
        "allow-seeking": "Seeking Forward",
        "control-card-extras": "Extra Control Card Features",
        "disable-chapters": "Don't Stop at Video Segments",
        "highlight-answers": "Show the Correct Answers",
        "test-notifications": "Test Notifications",
        "transfer-device": "Transfer to Another Device",
        "video-stats": "Video Stats in the Player"
      },
      "levels": "Levels",
      "reload-employees": "Reload Employees",
      "revision": "Revision: {{revision}}",
      "revision-updated": "Updated: <Ts/>",
      "support-agents": "Support Agents",
      "system": "System",
      "video-lessons": "Video Lessons",
      "welcome": "Welcome to the FSAcademy.bg administration area"
    },
    "client-home": {
      "broadcasts": "Notifications",
      "edit": "Edit",
      "employees-tooltip": "Manage employees",
      "locations-tooltip": "Manage locations",
      "managers-tooltip": "Manage managers",
      "planning": "Planning",
      "positions-tooltip": "Manage positions"
    },
    "home": "Home",
    "logout": "Logout",
    "manager": {
      "barsy-settings": "Barsy Settings",
      "broadcasts": "Send Notifications",
      "control-cards": "Control Cards",
      "employees": "Employees",
      "incoming-control": "Purchase Records",
      "locations": "Locations",
      "managers": "Managers",
      "mark-all-read": "Mark all as read",
      "no-new-notifications": "No new",
      "notifications": "Notifications ({{unread}})",
      "notifications-header": "Notifications (<strong>{{unread}}</strong> unread)",
      "positions": "Positions",
      "refresh-notifications": "Refresh notifications",
      "tickets": "Tickets",
      "training-plan": "Training Plan",
      "user-groups": "User Groups"
    },
    "my-profile": "My Profile",
    "test-mode": "Test Mode"
  },
  "organizer": {
    "archive-button-label": "Archive",
    "archive-document-message": "Are you sure you want to archive the document “{{name}}”?",
    "archive-document-title": "Archive Document",
    "archive-folder-message": "Are you sure you want to archive the folder “{{name}}” together with ALL documents in it?",
    "archive-folder-title": "Archive Folder",
    "column": {
      "state": "State",
      "valid-from": "From Date",
      "valid-until": "Expires On"
    },
    "create-document": "Create Document",
    "create-folder": "Create Folder",
    "expiration": {
      "expired": "Expired",
      "expires-soon": "Expires Soon"
    },
    "export": "Export",
    "export-tooltip_one": "The export will contain the selected {{count}} document.",
    "export-tooltip_other": "The export will contain the selected {{count}} documents.",
    "folder": {
      "add-title": "Add Folder",
      "edit-title": "Edit Folder {{name}}",
      "name-placeholder": "Folder name",
      "save-error": "Error saving the folder: {{message}}. Please try again"
    },
    "folder-tag": {
      "all-ok": "No expired, expiring or pending documents",
      "expired_one": "Expired: <strong>{{count}} document</strong>",
      "expired_other": "Expired: <strong>{{count}} documents</strong>",
      "expires-soon_one": "Expiring: <strong>{{count}} document</strong>",
      "expires-soon_other": "Expiring: <strong>{{count}} documents</strong>",
      "pending_one": "Pending: <strong>{{count}} document</strong>",
      "pending_other": "Pending: <strong>{{count}} documents</strong>"
    },
    "form": {
      "add-title": "Add Document",
      "current-state": "Current State",
      "duration-1-month": "1 Month",
      "duration-1-year": "1 Year",
      "duration-2-years": "2 Years",
      "duration-3-months": "3 Months",
      "duration-6-months": "6 Months",
      "earlier": "earlier",
      "edit-title": "Edit Document {{name}}",
      "folder": "Folder",
      "folder-placeholder": "Select a folder",
      "folder-required": "Select a folder",
      "name-placeholder": "Document name, e.g. Permit for...",
      "notes-placeholder": "Additional notes (if needed)",
      "quick-durations": "Quick Durations:",
      "reminder": "Send Me a Reminder",
      "reminder-description": "We will send a warning notification before the document expires",
      "valid-from": "Issue Date",
      "valid-from-placeholder": "Leave empty if there is no issue date",
      "valid-until-description": "We will send a notification when the document expires",
      "valid-until-placeholder": "Leave empty if there is no expiration"
    },
    "no-date": "No date",
    "no-expiration": "No expiration",
    "no-reminder": "No reminder",
    "notification-sent": "The notification for document <Name/> was sent",
    "reminder-line": "<strong>Reminder:</strong> <Dur/> earlier",
    "state": {
      "complete": "Completed",
      "pending": "Pending"
    },
    "title": "Organizer for Location <Name/>",
    "tooltip": {
      "archive-document": "Archive document <Name/>",
      "archive-folder": "Archive folder <Name/>",
      "download-pdf": "Download document <Name/> as PDF",
      "edit-document": "Edit document <Name/>",
      "edit-folder": "Edit folder <Name/>",
      "send-notification": "Send a notification now"
    }
  },
  "planning": {
    "column": {
      "type-period": "Type / Period"
    },
    "create-full": "Create Induction Course",
    "create-refresh": "Create Refresher Course",
    "delete-message": "Are you sure you want to delete this row?",
    "delete-title": "Delete Plan",
    "full": {
      "completion-time": "Time to Complete the Induction Course",
      "days-suffix_one": "day from starting work",
      "days-suffix_other": "days from starting work"
    },
    "no-plans": "There are no plans yet",
    "refresh": {
      "beyond-contract": "After the Contract End",
      "contract-tooltip": "The contract with FSAcademy expires before this date, on <Date/>. You need to renew your subscription",
      "end": "End",
      "end-before-start": "The course cannot end before it starts",
      "overlap": "This course overlaps with the course between {{from}} and {{to}}",
      "period": "Period:",
      "period-range": "from <From/> to <To/>",
      "start": "Start"
    },
    "row": {
      "lesson-count": "Topics: <strong>{{total}}</strong>",
      "selected-lessons": "Selected topics: <strong>{{selected}} of {{total}}</strong>"
    },
    "title": "Yearly Training Plan"
  },
  "position": {
    "form": {
      "new-title": "New Position",
      "new-title-named": "New Position: <Name/>"
    },
    "list": {
      "add": "Add New Position",
      "edit-tooltip": "Edit position",
      "title": "Positions"
    }
  },
  "schedule": {
    "day": {
      "fri": "Fri",
      "mon": "Mon",
      "sat": "Sat",
      "sun": "Sun",
      "thu": "Thu",
      "tue": "Tue",
      "wed": "Wed"
    },
    "day-full": {
      "fri": "Friday",
      "mon": "Monday",
      "sat": "Saturday",
      "sun": "Sunday",
      "thu": "Thursday",
      "tue": "Tuesday",
      "wed": "Wednesday"
    },
    "day-of-month": "Day of the Month",
    "edit-title": "Editing <Label/>",
    "every-day": "Every Day",
    "every-month": "Every Month",
    "fallback-label": "schedule",
    "frequency": "Frequency",
    "human": {
      "day-fallback": "day {{day}}",
      "every-day": "every day",
      "first-workday": "On the first workday",
      "last-day": "On the last day of the month",
      "last-nth-day": "the last {{day}} of the month",
      "last-workday": "On the last workday of the month",
      "nth-day": "{{pos}} {{day}} of the month",
      "on-day": "on the {{ordinal}} of the month",
      "sentence": "{{dayPart}} at {{time}}{{monthPart}}"
    },
    "mode": {
      "day-of-month": "By Day of the Month",
      "day-of-week": "By Day of the Week",
      "nth-day-of-week": "By Day of the Week in the Month"
    },
    "month": {
      "apr": "April",
      "aug": "August",
      "dec": "December",
      "feb": "February",
      "jan": "January",
      "jul": "July",
      "jun": "June",
      "mar": "March",
      "may": "May",
      "nov": "November",
      "oct": "October",
      "sep": "September"
    },
    "months": "Months",
    "none": "No schedule",
    "nth": {
      "first": "the first",
      "fourth": "the fourth",
      "second": "the second",
      "third": "the third"
    },
    "nth-option": {
      "first": "The First",
      "fourth": "The Fourth",
      "last": "The Last",
      "second": "The Second",
      "third": "The Third"
    },
    "preset": {
      "first-workday": "On the first workday",
      "last-day": "On the last day",
      "last-workday": "On the last workday",
      "on-day": "On the {{ordinal}}"
    },
    "preview": {
      "calculating": "Calculating...",
      "invalid": "Invalid schedule",
      "request-error": "Request error"
    },
    "preview-dates": "Dates of the Selected Schedule",
    "quick": {
      "every-day": "Every day at 6:00",
      "every-monday": "Every Monday at 6:00",
      "every-workday": "Every workday at 6:00",
      "first-day-of-month": "The 1st of the month at 6:00",
      "first-monday-of-month": "The first Monday of the month at 6:00",
      "first-workday-of-month": "The first workday of the month at 6:00",
      "label": "Quick Schedule",
      "placeholder": "Select a template..."
    },
    "time": "Time",
    "type-disabled": "Without Schedule",
    "type-enabled": "With Schedule"
  },
  "ticket": {
    "column": {
      "control-card": "Control Card",
      "created": "Created",
      "files": "Files",
      "subject": "Subject",
      "to": "To",
      "updated": "Updated"
    },
    "delete": {
      "message": "Are you sure you want to delete ticket <Number/>?",
      "message-with-subject": "Are you sure you want to delete ticket <Number/>: {{subject}}?",
      "title": "<mark>Delete</mark> Ticket",
      "toast": "Ticket {{number}} was deleted successfully"
    },
    "detail": {
      "change-status": "Change Status",
      "delete-toast": "The ticket was deleted successfully",
      "join": "Join",
      "join-error": "Error joining the ticket",
      "join-toast": "You joined the ticket",
      "join-tooltip": "Add yourself as a recipient of the ticket",
      "leave": "Leave",
      "leave-error": "Error leaving the ticket",
      "leave-toast": "You left the ticket",
      "leave-tooltip": "Remove yourself from the ticket's recipients",
      "loading-title": "Loading...",
      "message-placeholder": "Write a message...",
      "messages": "Messages ({{messages}})",
      "new-message": "New Message",
      "status-change-error": "Error changing the status",
      "status-changed-by": "Status changed by {{name}} — <Ts/>",
      "status-changed-toast": "The status was changed to \"{{status}}\"",
      "status-message": "{{name}} changed the status to “{{status}}” — <Ts/>",
      "title": "Ticket <Number/>"
    },
    "for-locations": "For Locations",
    "form": {
      "content-placeholder": "Add details that would help resolve the ticket",
      "edit-title": "Edit Ticket #{{number}}",
      "locations-description": "Which locations the ticket concerns, if applicable",
      "locations-placeholder": "Select locations",
      "recipients-required": "Select at least one recipient",
      "save-error": "Error saving: {{message}}. Please try again",
      "subject-placeholder": "What is the ticket about"
    },
    "list": {
      "add": "New Ticket",
      "title": "Tickets",
      "view-files": "View ({{files}})"
    },
    "recipients": {
      "manager": "Manager",
      "only-employees": "Only Employees",
      "only-managers": "Only Managers",
      "search-placeholder": "By name, position or location",
      "title": "Select Recipients"
    },
    "search": {
      "direction": "Direction",
      "for-me": "For Me",
      "from-me": "From Me",
      "no-location": "No Location",
      "placeholder": "Search tickets..."
    },
    "status": {
      "done": "Completed",
      "in-progress": "In Progress",
      "todo": "To Do"
    }
  },
  "user-group": {
    "archive": {
      "message_one": "Are you sure you want to archive the selected group?",
      "message_other": "Are you sure you want to archive the selected {{count}} groups?",
      "note": "Control cards that already use these groups will keep filtering users by them until they are removed from the corresponding column. Archived groups cannot be selected again.",
      "title": "Archiving Groups",
      "toast-errors": "Errors while archiving: {{errors}}",
      "toast-success_one": "Archived {{count}} group",
      "toast-success_other": "Archived {{count}} groups",
      "toast-title": "Archive result"
    },
    "column": {
      "member-count": "Members"
    },
    "form": {
      "load-error": "Failed to load the group.",
      "members": "Members ({{members}})",
      "members-empty": "Select users",
      "new-title": "New User Group",
      "new-title-named": "New User Group: <Name/>",
      "save-error": "Error saving the group: {{message}}. Please try again",
      "save-success": "Successfully saved group {{name}}"
    },
    "list": {
      "add": "Add New Group",
      "archive-restore": "Archive / Restore …",
      "archived-icon": "The group is archived",
      "edit-tooltip": "Edit user group",
      "title": "User Groups"
    },
    "restore": {
      "toast-errors": "Errors while restoring: {{errors}}",
      "toast-success_one": "Restored {{count}} group",
      "toast-success_other": "Restored {{count}} groups",
      "toast-title": "Restore result"
    },
    "search": {
      "include-archived": "Show Archived Too",
      "placeholder": "By name"
    }
  },
  "video-lesson": {
    "answer": {
      "archive": "Archive (hide) the answer",
      "correct": "Correct Answer",
      "label": "Answer {{pos}}. (content)",
      "remove": "Remove This Answer"
    },
    "column": {
      "score-to-pass": "Pass Percentage",
      "title": "Title"
    },
    "form": {
      "add-chapter": "Add Chapter",
      "add-question": "Add Question",
      "chapter-count": "Number of chapters: ({{chapters}})",
      "chapter-end": "Chapter end in the video",
      "new-title": "New Video Lesson",
      "new-title-named": "New Video Lesson: <Name/>",
      "no-chapters": "No chapters defined",
      "remove-chapter": "Remove This Chapter",
      "saved-toast": "Done",
      "score-to-pass": "Required percentage of correct answers to pass",
      "tab": {
        "chapters": "Chapters",
        "main": "General",
        "questions": "Test Questions",
        "test": "Lesson Test"
      },
      "thumbnail": "Thumbnail",
      "video-files": "Video Files"
    },
    "length": "Duration",
    "list": {
      "add": "Add New Video Lesson",
      "edit-tooltip": "Edit video lesson",
      "title": "Video Lessons"
    },
    "player": {
      "rewind": "Rewind"
    },
    "question": {
      "add-answer": "Add Answer",
      "answer-end": "End of the relevant part of the video",
      "answer-start": "Start of the relevant part of the video",
      "answers-title": "Question Answers",
      "archive": "Archive (hide) the question",
      "remove": "Remove This Question",
      "required-to-pass": "Required to pass the test",
      "score": "Points",
      "title": "Question #{{pos}}"
    },
    "watch": "Watch",
    "watch-excerpt": "Watch Excerpt"
  }
}
